import React, { Component } from 'react';
import Switch from 'react-switch';
import '../../../css/Announcement/AnnouncementSettings.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { PortAlphaSorting } from '../../../Services/utils/AlphaSorting';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { ALLPORTTERMINALS_ENDPOIN, SINGLE_USER_PORT_PREFERENCE_ENDPOINT
} from '../../../Services/config/apiEndPoints';
import { AES, enc } from 'crypto-js';
import { connect } from 'react-redux';
class AnnouncementSettings extends Component {
  constructor() {
    super();
    this.state = {
      terminalData: [],
      st: {},
      apiStack: []
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentWillMount() {
    ApiCall(
      'GET',
      utilityBaseURL + ALLPORTTERMINALS_ENDPOIN,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    ).then((data) => {
      if (data.flag != -1) {
        if (data.flag == 500) {
          console.log('I am 500!');
        } else {
          console.log('I am 200!');
          data = PortAlphaSorting(data);
          this.setState({ terminalData: data }, () => {
            let st = {};
            this.state.terminalData?.forEach((s, index) => {
              st[s.portId] = false;
            });
            this.setState({ st: st }, () => this.getSettingsData());
          });
        }
      }
    });
  }
  toggleSwitchApiCall(portId) {
    if (this.state.apiStack.indexOf(portId) == -1) {
      let st = this.state.st;
      var currentStatus = st[portId];
      st[portId] = !st[portId];
      var apiStack = this.state.apiStack;
      apiStack.push(portId);
      this.setState({ st: st, apiStack: apiStack }, () => {
        ApiCall(
          'PUT',
          utilityBaseURL + SINGLE_USER_PORT_PREFERENCE_ENDPOINT,
          {
            "preference": {
              "terminalId": portId,
              "terminalName": "string"
            },
            "selected": !currentStatus,
            "user": this.props.userProfileDataR?.userEmail
          },
          {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        ).then((data) => {
          if (data.flag != -1) {
              console.log('flag');
          }
          else {
            let std = this.state.st;
            st[portId] = currentStatus;
            this.setState({ st: std }, () => {
            });
          }
          var apiStackd = this.state.apiStack;
          apiStackd.splice(apiStackd.indexOf(portId), 1)
          this.setState({ apiStack: apiStackd });
        });
      });
    }
  }
  handleChange(checked) {
    this.setState({ checked });
  }
  getSettingsData() {
    ApiCall(
      'GET',
      utilityBaseURL + SINGLE_USER_PORT_PREFERENCE_ENDPOINT,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    ).then((data) => {
      if (data.flag != -1) {
        console.log('I am 200!');
        let st = this.state.st;
        data?.portIds?.forEach((p) => (st[p] = true));
        
        this.setState({ st: st });
      }
    });
  }
  render() {
    return (
      <div >
        <MetaDecorator title={TitleDescription.announcementSettingsPageTitle} description={TitleDescription.announcementSettingsPageDescription} />
        <Header  tilesFetched = {()=>{}}/>
        <div class="ansfull">
          <div className='annweathernavbar'>
            <small id="announcmentname">Announcement Settings</small>
          </div><hr className='navbarhr' />
          <div className='annsettingsectionPart'>
            <div>
              <p className='heading'>Get notification for your preferred terminals</p>
            </div>
            <div class="settingdata">
              {(this.state.terminalData?.map((s, index) => {
                return (
                  <div key={index}>
                    <div className='group'>
                      <p className='preferredterminal'>{s.portName?.split(':')[0]}</p>
                      <Switch
                        onChange={() => {
                          this.toggleSwitchApiCall(s.portId)
                        }}
                        checked={this.state.st[s.portId]}
                        uncheckedIcon={false}
                        checkedIcon={false}
                      />
                    </div>
                    <hr className='borderbottomsetting' />
                  </div>
                );
              }))}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
function mapStateToProps(state) {
  if(state.userProfileInfoReducer.data){
  return {
    userProfileDataR:JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8))
  }
}
}
export default connect(mapStateToProps)(AnnouncementSettings);
